<div class="container">

  <div class="header">
    <div class="header-top">
      <div class="header-left">
        <app-page-close-button (click)="goBack()"></app-page-close-button>
        <div class="title-container">
          <span class="title">
            @if (readOnlyMode) { View } @else if(customerEditingEnabled) { Edit
            } @else { Add } Customer
          </span>
        </div>
      </div>
      <div class="header-right">
        <ng-container *ngIf="!readOnlyMode">
          <button type="button" class="secondary_button" (click)="goBack()">
            Cancel
          </button>
          <button
            type="button"
            class="primary_button"
            [disabled]="disableAction"
            (click)="submitCustomerForm()"
          >
            @if(customerEditingEnabled) { Update } @else { Save }
          </button>
        </ng-container>
      </div>
    </div>
  </div>

  <app-horizontal-tabs
    [tabs]="tabList"
    [selectedTab]="selectedTab"
    (tabSelected)="selectTab($event)"
  ></app-horizontal-tabs>


  <div class="container-content" [hidden]="selectedTab !== 'BasicDetails'">
    <form [formGroup]="customerForm">

      <div
        id="basic-details-section"
        class=""
      >
        <div class="section">
          <app-custom-accordion title="Tax & Legal Identification" subtitle="Essential identification numbers for businesses">
            <div class="radio-container">
              <label class="select-label required_field_label">Select</label>

              <div class="radio-group">
                <div class="radio-item">
                  <input
                    type="radio"
                    id="pan"
                    name="idType"
                    value="pan"
                    (change)="changeLabel('pan')"
                    [checked]="selectedOption === 'pan'"
                  />
                  <label for="pan">PAN</label>
                </div>

                <div class="radio-item">
                  <input
                    type="radio"
                    id="trc"
                    name="idType"
                    value="trc"
                    (change)="changeLabel('trc')"
                    [checked]="selectedOption === 'trc'"
                  />
                  <label for="trc">TRC No</label>
                </div>
              </div>
            </div>

            <div class="grid-container">
              <div class="pan-group">
                <div class="form-group">
                  <label for="panNumber" class="required_field_label">
                    {{
                      selectedOption === "trc" ? "Enter TRC " : "Enter PAN "
                    }}
                  </label>
                  <input
                    id="panNumber"
                    name="panNumber"
                    formControlName="panNumber"
                    #formField
                    type="text"
                    placeholder="Enter {{ selectedOption === 'trc' ? 'TRC' : 'PAN' }} Number"
                    required
                    uppercaseInput
                    (input)="onPanNumberChange($event)"
                  />

                  <div class="form_validation_error_new" [ngClass]="{'visible': customerForm.get('panNumber')?.invalid && customerForm.get('panNumber')?.touched}">
                    <small *ngIf="customerForm.get('panNumber')?.errors?.['required']">{{ selectedOption === "trc" ? "TRC Number" : "PAN Number" }} is required</small>
                    <small *ngIf="customerForm.get('panNumber')?.errors?.['pattern']">Invalid PAN Number</small>
                  </div>
                </div>

                <div class="pan-validator" *ngIf="validatePanNumber">
                  <button type="button" class="tertiary_button" (click)="checkIfPanNumberIsAllowed()">Validate</button>
                </div>
              </div>
            </div>
          </app-custom-accordion>
        </div>

        <div class="section">
          <app-custom-accordion
          title="Basic Information"
          subtitle="Fill in customer details"
          [disabled]="accDisabled"
          >
          <div class="basic-info-container form-container">
            <div class="grid-container  grid-5">

              <div class="form-group">
                <label for="code" class="required_field_label">Customer Code</label>
                <input id="code" name="code" formControlName="code" #formField type="text" placeholder="Enter Code" maxlength="20" required codeFormat />
                <div class="form_validation_error_new" [ngClass]="{'visible': customerForm.get('code')?.invalid && customerForm.get('code')?.touched}">
                  <small *ngIf="customerForm.get('code')?.errors?.['required']">Customer Code is required</small>
                  <small *ngIf="customerForm.get('code')?.errors?.['maxlength']">Customer Code must be less than 10 characters</small>
                </div>
              </div>

              <div class="form-group">
                <label for="name" class="required_field_label">Customer Name</label>
                <input id="name" name="name" formControlName="name" #formField type="text" placeholder="Enter name" required autocomplete="name" />
                <div class="form_validation_error_new" [ngClass]="{'visible': customerForm.get('name')?.invalid && customerForm.get('name')?.touched}">
                  <small *ngIf="customerForm.get('name')?.errors?.['required']">Customer Name is required</small>
                </div>
              </div>

            </div>

            <div class="grid-container grid-5">
              <div class="form-group">
                <label for="customerType" class="required_field_label">Customer Type</label>
                <app-multi-select
                id="customerType"
                [options]="customerTypes"
                [returnRawValue]="false"
                [displayKey]="'name'"
                [valueKey]="'value'"
                [isMultiSelect]="true"
                [placeholder]="'Select Customer Type'"
                [formControlName]="'customerType'"
                (selectedItemsChange)="onCustomerTypeChange($event)"
                >
                </app-multi-select>
                <div class="form_validation_error_new" [ngClass]="{'visible': customerForm.get('customerType')?.invalid && customerForm.get('customerType')?.touched}">
                  <small *ngIf="customerForm.get('customerType')?.errors?.['required']">Customer Type is required</small>
                </div>
              </div>

              <div class="form-group">
                <app-toggle
                  formControlName="nominated"
                  [toggleId]="'nominated'"
                  [label]="'Nominated'"
                  [isActive]="customerForm.get('nominated')?.value"
                  [disable]="readOnlyMode"
                ></app-toggle>
              </div>

            </div>


            <div class="grid-container grid-5">
              <div class="form-group">
                <label for="parentCustomerId">Parent Customer</label>
                <app-autocomplete-dropdown
                  id="parentCustomerId"
                  name="parentCustomerId"
                  formControlName="parentCustomerId"
                  [placeholder]="'Select Parent Customer'"
                  [apiUrl]="'v1/customers/list'"
                  [filterByKeys]="['NAME_CONTAINS']"
                  [limit]="10"
                  [orderBy]="{ name: 'asc' }"
                  [bindLabel]="'name'"
                  [bindValue]="'id'"
                  [displayColumns]="[
                    { key: 'name', header: 'Name' },
                  ]"
                  [disable]="readOnlyMode"
                  [returnRawValue]="false"
                ></app-autocomplete-dropdown>
                <div class="form_validation_error_new" [ngClass]="{'visible': customerForm.get('parentCustomerId')?.invalid && customerForm.get('parentCustomerId')?.touched}">
                  <small *ngIf="customerForm.get('parentCustomerId')?.errors?.['required']">Parent Customer is required</small>
                </div>
              </div>

              <div class="form-group">
                <label for="sisterCustomerId">Sister Customer</label>
                <app-autocomplete-dropdown
                  id="sisterCustomerId"
                  name="sisterCustomerId"
                  formControlName="sisterCustomerId"
                  [placeholder]="'Select Sister Customer'"
                  [apiUrl]="'v1/customers/list'"
                  [filterByKeys]="['NAME_CONTAINS']"
                  [limit]="10"
                  [orderBy]="{ name: 'asc' }"
                  [bindLabel]="'name'"
                  [bindValue]="'id'"
                  [displayColumns]="[
                    { key: 'name', header: 'Name' },
                  ]"
                  [disable]="readOnlyMode"
                  [returnRawValue]="false"
                ></app-autocomplete-dropdown>
              </div>

              <div class="form-group">
                <app-toggle formControlName="active"
                  [toggleId]="'active'"
                  [label]="'Active'"
                  [isActive]="customerForm.get('active')?.value"
                  [disable]="readOnlyMode"
                ></app-toggle>
              </div>
            </div>
          </div>
          </app-custom-accordion>
        </div>

        <div class="section">
          <app-custom-accordion
          title="Customer Tax & Credit Details"
          subtitle="Fill in Tax and Credit details"
          [disabled]="accDisabled"
          >
            <div class="form-container">

              <div class="grid-container grid-5">
                <div class="form-group">
                  <label for="salesPerson">Sales Person</label>
                  <app-autocomplete-dropdown
                    id="salesPerson"
                    name="salesPerson"
                    formControlName="salesPerson"
                    [placeholder]="'Select Sales Person'"
                    [apiUrl]="'v1/users/list'"
                    [filterByKeys]="['NAME_CONTAINS']"
                    [limit]="10"
                    [orderBy]="{ name: 'asc' }"
                    [bindLabel]="'name'"
                    [bindValue]="'id'"
                    [displayColumns]="[
                      { key: 'name', header: 'Name' },
                    ]"
                    [disable]="readOnlyMode"
                    [returnRawValue]="false"
                  ></app-autocomplete-dropdown>
                </div>

                <div class="form-group">
                  <label for="tanNumber">TAN Number</label>
                  <input id="tanNumber" name="tanNumber" formControlName="tanNumber" type="text" placeholder="Enter TAN Number" />
                  <div class="form_validation_error_new" [ngClass]="{'visible': customerForm.get('customerType')?.invalid && customerForm.get('customerType')?.touched}">
                    <small *ngIf="customerForm.get('tanNumber')?.errors?.['required']">TAN Number is required</small>
                  </div>
                </div>

                <div class="form-group">
                  <label for="importerExporterCode">Importer/Exporter Code</label>
                  <input id="importerExporterCode" name="importerExporterCode" formControlName="importerExporterCode" type="text" placeholder="Enter Importer/Exporter Code" />
                </div>
              </div>

              <div class="grid-container grid-5">
                <div class="form-group">
                  <app-toggle formControlName="creditEnabled" [toggleId]="'creditEnabled'" [label]="'Credit Allowed'" [isActive]="customerForm.get('creditEnabled')?.value" (toggleChange)="onCreditEnabledChange($event)" [disable]="readOnlyMode"></app-toggle>
                </div>

                <div class="form-group">
                  <label for="creditEnabledCycles" class="required_field_label">Credit Cycle</label>
                  <app-multi-select
                  [options]="cycleOptions"
                  [returnRawValue]="false"
                  [displayKey]="'value'"
                  [valueKey]="'key'"
                  [isMultiSelect]="true"
                  [placeholder]="'Select Credit Cycle'"
                  [formControlName]="'creditEnabledCycles'"
                  [showChips]="false"
                  >
                  </app-multi-select>
                  <div class="form_validation_error_new" [ngClass]="{'visible': customerForm.get('creditEnabledCycles')?.invalid && customerForm.get('creditEnabledCycles')?.touched}">
                    <small *ngIf="customerForm.get('creditEnabledCycles')?.errors?.['required']">Credit Cycle is required</small>
                  </div>
                </div>

                <div class="form-group">
                  <label for="creditLimit">Credit Limit</label>
                  <input id="creditLimit" name="creditLimit" formControlName="creditLimit" type="number" placeholder="Enter Credit Limit" />
                  <div class="form_validation_error_new" [ngClass]="{'visible': customerForm.get('creditLimit')?.invalid && customerForm.get('creditLimit')?.touched}">
                    <small *ngIf="customerForm.get('creditLimit')?.errors?.['required']">Credit Limit is required</small>
                  </div>
                </div>

                <div class="form-group">
                  <label for="creditDays">Credit Days</label>
                  <input id="creditDays" name="creditDays" formControlName="creditDays" type="number" placeholder="Enter Credit Days" />
                  <div class="form_validation_error_new" [ngClass]="{'visible': customerForm.get('creditDays')?.invalid && customerForm.get('creditDays')?.touched}">
                    <small *ngIf="customerForm.get('creditDays')?.errors?.['required']">Credit Days is required</small>
                  </div>
                </div>


              </div>

              <div class="grid-container grid-5">
                <div class="form-group">
                  <app-toggle formControlName="pdaEnabled" [toggleId]="'pdaEnabled'" [label]="'PDA Allowed'" [isActive]="customerForm.get('pdaEnabled')?.value" (toggleChange)="onPdaEnabledChange($event)" [disable]="readOnlyMode"></app-toggle>
                </div>

                <div class="form-group">
                  <label for="pdaEnabledCycles" class="required_field_label">PDA Cycle</label>
                  <app-multi-select
                  [options]="cycleOptions"
                  [returnRawValue]="false"
                  [displayKey]="'value'"
                  [valueKey]="'key'"
                  [isMultiSelect]="true"
                  [placeholder]="'Select PDA Cycle'"
                  [formControlName]="'pdaEnabledCycles'"
                  [showChips]="false"
                  >
                  </app-multi-select>
                  <div class="form_validation_error_new" [ngClass]="{'visible': customerForm.get('pdaEnabledCycles')?.invalid && customerForm.get('pdaEnabledCycles')?.touched}">
                    <small *ngIf="customerForm.get('pdaEnabledCycles')?.errors?.['required']">PDA Cycle is required</small>
                  </div>
                </div>

                <div class="form-group">
                  <label for="pdaCreditLimit">PDA Credit Limit</label>
                  <input id="pdaCreditLimit" name="pdaCreditLimit" formControlName="pdaCreditLimit" type="number" placeholder="Enter PDA Limit" />
                </div>
              </div>

            </div>

          </app-custom-accordion>
        </div>
      </div>
    </form>
  </div>

  <div
    id="contact-information-section" class="contact-section-container"
    [hidden]="selectedTab !== 'ContactInformation'"
  >
    <div class="contact-section">

      <div class="header-top contact-header">
        <div class="header-left">
          <span class="section-title">Contacts</span>
        </div>

        <div class="header-right" *ngIf="!readOnlyMode && contactList.length > 0">
          <button type="button" class="tertiary_button" (click)="addContact()">
            <app-svg-icon [path]="'assets/icons/add_plus_icon.svg'"></app-svg-icon>
            Add New Contact</button>
        </div>
      </div>

      @if(contactList.length > 0) {
      <div class="contact-list" >
        <div class="contact-item" *ngFor="let contact of contactList; let i = index">
          <app-item-card
          [title]="contact.contactName"
          [lines]="getFormattedContactSummary(i)"
          [badges]="getContactBadges(i)"
          [actions]="contactActions"
          (actionClicked)="handleContactAction(i, $event)"
          ></app-item-card>
        </div>
      </div>
      } @else {
        <div class="empty-state-container">
          <app-no-data [msg]="'No contacts added yet'" [path]="'assets/icons/empty_contacts_icon.svg'"></app-no-data>
          <button type="button" class="tertiary_button" *ngIf="!readOnlyMode" (click)="addContact()">
            <app-svg-icon [path]="'assets/icons/add_plus_icon.svg'"></app-svg-icon>
            Add New Contact</button>
        </div>
      }
    </div>
  </div>

</div>
